<template>
  <div class="section-aside__aside section-aside__aside--sticky sticky-el">
    <div class="order-card">
      <div class="order-card__top">
        <div class="order-card__title">{{ title }}</div>
        <div class="order-card__subtitle">{{ subTitle }}</div>
      </div>
      <div class="order-card__bottom">

        <div class="order-card__quantity" v-if="$slots.quantity">
          <div class="order-card__quantity-text">{{ quantityTitle }}</div>
          <slot name="quantity"></slot>
          <!--                    <div class="quantity quantity&#45;&#45;bg">-->
          <!--                        <button class="quantity__link quantity__link&#45;&#45;minus"></button>-->
          <!--                        <input class="quantity__control" type="number" value="100" min="0" step="10">-->
          <!--                        <button class="quantity__link quantity__link&#45;&#45;plus"></button>-->
          <!--                    </div>-->
        </div>

        <div class="order-card__btns">
          <slot>

          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IPAside",
  props: {
    title: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ASIDE_TITLE')
    },
    subTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ASIDE_SUBTITLE')
    },
    quantityTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ASIDE_QUANTITY')
    },
  }
}
</script>

<style scoped>

</style>